export const notificationMixin = {
  methods: {
    isNotLastMessage(totalItems, index) {
      return (totalItems - 1) !== index;
    }
  }
};
